<template>

	<header class="title-header">
		<div class="backdrop">
			<h3 class="subtitle">{{ subtitle }}</h3>
			<h2 class="title">{{ title }}</h2>
		</div>
	</header>
	
</template>

<script>
	
	export default {
		name: 'TitleHeader',
		
		props: ['subtitle', 'title']
	}
	
</script>